import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=1e3c9667&scoped=true&"
import script from "./Area.vue?vue&type=script&lang=ts&"
export * from "./Area.vue?vue&type=script&lang=ts&"
import style0 from "./Area.vue?vue&type=style&index=0&id=1e3c9667&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c9667",
  null
  
)

export default component.exports